export enum UserRole {
  admin = 'admin',
  employee = 'employee',
  group = 'group',
}
